const BASE = '/api';

export interface Cliente {
  id: number;
  nome: string;
  telefone: string;
  endereco: string | null;
  observacoes: string | null;
  ativo: boolean;
  criado_em: string;
  atualizado_em: string;
}

export interface NovoClienteInput {
  nome: string;
  telefone: string;
  endereco?: string | null;
  observacoes?: string | null;
}

async function jsonReq<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const body = await r.json().catch(() => ({}));
  if (r.status === 401) window.dispatchEvent(new CustomEvent('auth:expirou'));
  if (!r.ok) throw new Error((body as { erro?: string })?.erro || `HTTP ${r.status}`);
  return body as T;
}

export async function listarClientes(): Promise<Cliente[]> {
  const r = await jsonReq<{ ok: boolean; clientes: Cliente[] }>(`/clientes`);
  return r.clientes;
}

export async function criarCliente(input: NovoClienteInput): Promise<Cliente> {
  const r = await jsonReq<{ ok: boolean; cliente: Cliente }>(`/clientes`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.cliente;
}

export async function atualizarCliente(id: number, patch: Partial<NovoClienteInput> & { ativo?: boolean }): Promise<Cliente> {
  const r = await jsonReq<{ ok: boolean; cliente: Cliente }>(`/clientes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.cliente;
}

export async function removerCliente(id: number): Promise<void> {
  await jsonReq<{ ok: boolean }>(`/clientes/${id}`, { method: 'DELETE' });
}
